import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Advanced from "./Advanced";
import NextSchedule from "./NextSchedule";
import { SCHEDULE_TYPES } from "App/componentsConfig";
import { forbidExtraProps } from "utils";
import { objectToArray } from "utils";
import {
  toggleScheduleType,
  toggleScheduleRetention,
  toggleScheduleDevice,
  toggleScheduleLoginDetails
} from "store/actions";

function Schedule(props) {
  const currentType =
    props.enums.ScheduleType.props[props.scheduleInfo.type.current];

  return (
    <React.Fragment>
      <div className="schedule_backup_wrap">
        <div className="schedule_backup_tabs">
          <ul className="schedule_backup_ul">
            {objectToArray(SCHEDULE_TYPES).map((val, i) => {
              const enumKey = props.enums.ScheduleType[val.key];

              return (
                <li key={i}>
                  <label className="radio_container">
                    <input
                      type="radio"
                      className="input_radio"
                      checked={enumKey === props.scheduleInfo.type.current}
                      name="initial_backup_radio"
                      value={i}
                      onChange={() => props.toggleScheduleType(enumKey)}
                      tabIndex={0}
                    />
                    <span className="radio_checkmark" />
                    <span className="fs_16">{val.name}</span>
                  </label>
                </li>
              );
            })}
          </ul>
        </div>

        <div
          className={[
            "schedule_backup_body",
            "transparent_layer_wrap",
            "transparent_layer_schedule",
            currentType.key === "NO_SCHEDULE" ? "layer_active" : null
          ].join(" ")}
        >
          <div className="transparent_layer" />
          <div
            className={[
              "sche_backup_item",
              currentType.key === "NO_SCHEDULE"
                ? "backup_" +
                  props.enums.ScheduleType.props[props.scheduleInfo.type.past]
                    .name
                : "backup_" + currentType.name,
              "active"
            ].join(" ")}
          >
            {React.createElement(
              SCHEDULE_TYPES[
                currentType.key === "NO_SCHEDULE"
                  ? props.enums.ScheduleType.props[props.scheduleInfo.type.past]
                      .key
                  : currentType.key
              ].component
            )}
          </div>
        </div>
        <NextSchedule
          scheduleInfo={props.scheduleInfo}
          enums={props.enums}
          clients={props.clients}
          clientDetails={props.clientDetails}
        />
      </div>

      <Advanced
        scheduleInfo={props.scheduleInfo}
        toggleScheduleRetention={props.toggleScheduleRetention}
        toggleScheduleLoginDetails={props.toggleScheduleLoginDetails}
        toggleScheduleDevice={props.toggleScheduleDevice}
      />
    </React.Fragment>
  );
}

Schedule.propTypes = forbidExtraProps(
  {
    scheduleInfo: PropTypes.shape({
      type: PropTypes.shape({
        current: PropTypes.oneOf([0, 1, 2, 3]).isRequired
      }).isRequired,
      startTime: PropTypes.shape({
        value: PropTypes.number.isRequired
      }).isRequired,
      weekDays: PropTypes.arrayOf(PropTypes.number).isRequired,
      advanced: PropTypes.shape({
        onWakeup: PropTypes.shape({
          checked: PropTypes.bool.isRequired,
          password: PropTypes.string,
          userName: PropTypes.string
        }),
        performShutdown: PropTypes.bool.isRequired,
        preventSleep: PropTypes.bool.isRequired,
        runMissed: PropTypes.bool.isRequired
      }).isRequired
    }).isRequired
  },
  [
    "enums",
    "toggleScheduleType",
    "toggleScheduleRetention",
    "toggleScheduleDevice",
    "toggleScheduleLoginDetails",
    "clients",
    "clientDetails"
  ]
);

function mapStateToProps(state) {
  return {
    scheduleInfo: state.backupSettings.scheduleInfo,
    enums: state.common.enums,
    clients: state.dashboard.clients.list,
    clientDetails: state.backupSettings.clientDetails
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleScheduleType,
      toggleScheduleRetention,
      toggleScheduleDevice,
      toggleScheduleLoginDetails
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Schedule);
